import PropTypes from 'prop-types';
import React from 'react';

import { Spinner } from '@bibliocommons/base-icons';

import BackLink from 'app/components/admin/browse/shared/BackLink';
import { LOCALE_CODE } from 'app/constants/language';
import { makeHomeListPageRoute } from 'app/helpers/admin/browse/home';
import { browseHomePageShape } from 'app/shapes/admin/browse/home';
import AdminBrowseHomeEditForm from './AdminBrowseHomeEditForm';

import './AdminBrowseHomeEditPage.scss';

const AdminBrowseHomeEditPage = ({
  browseHomePage,
  errorMessage,
  hasUnsavedChanges,
  isFetching,
  isSaving,
  localeCode,
  onChange,
  onSave
}) => {
  return (
    <div className="cp-admin-browse-home-edit-page container">
      <BackLink
        className="back-link"
        dataKey="back-to-home-pages"
        label="Back to Browse Home"
        url={makeHomeListPageRoute(localeCode)}
      />

      {isFetching && (
        <div>
          <Spinner />
        </div>
      )}

      {errorMessage && <p style={{ color: '#cc441e', fontWeight: 'bold' }}>{errorMessage}</p>}

      {!isFetching && Boolean(browseHomePage) && (
        <AdminBrowseHomeEditForm
          browseHomePage={browseHomePage}
          hasUnsavedChanges={hasUnsavedChanges}
          isSaving={isSaving}
          onChange={onChange}
          onSave={onSave}
        />
      )}
    </div>
  );
};

AdminBrowseHomeEditPage.defaultProps = {
  errorMessage: ''
};

AdminBrowseHomeEditPage.propTypes = {
  browseHomePage: browseHomePageShape,
  errorMessage: PropTypes.string,
  hasUnsavedChanges: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  isSaving: PropTypes.bool.isRequired,
  localeCode: PropTypes.oneOf(Object.values(LOCALE_CODE)).isRequired,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired
};

export default AdminBrowseHomeEditPage;
